module.exports = global["_"] = require("-!./index.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/expose-loader?_!../node_modules/lodash/index.js-exposed
// module id = 258
// module chunks = 3